import ScrollTrigger from 'gsap/ScrollTrigger';
import gsap from 'gsap'
import Block from './Block'

gsap.registerPlugin(ScrollTrigger);

export default class Products extends Block {
  onEnterCompleted() {
    super.onEnterCompleted()

    this.figureOutType()
    this.reveal()
  }

  getElems() {
    super.getElems()
    this.$sections = this.el.querySelectorAll('section')
    this.$imgs = this.el.querySelectorAll('.lazy')

    for (let i = 0; i < this.$imgs.length; i++) {
      const img = this.$imgs[i];

      img.addEventListener('load', () => {
        ScrollTrigger.refresh()
      })
    }
  }

  figureOutType() {
    this.sectionsDatas = []

    for (let i = 0; i < this.$sections.length; i++) {
      const section = this.$sections[i];
      let type
      let hasContent = false

      if (section.querySelector('.c-content') !== null) hasContent = true
      if (section.classList.contains('b-pictos')) type = 'b-pictos'
      if (section.classList.contains('b-mozaic')) type = 'b-mozaic'

      this.sectionsDatas.push({
        el: section,
        hasContent,
        type
      })
    }
  }

  revealContent(component) {
    this.$title = component.querySelector('.content__title')
    this.$suptitle = component.querySelector('.content__suptitle')
    this.$text = component.querySelector('.content__text')
    this.$cta = component.querySelector('.cta')

    const tl = gsap.timeline()

    tl.fromTo(this.$title, {
      opacity: 0,
      y: -50
    }, {
      duration: 0.5,
      ease: 'power2',
      opacity: 1,
      y: 0
    })

    tl.addLabel('second', '>-=0.5')

    tl.fromTo(this.$suptitle, {
      opacity: 0
    }, {
      duration: 0.5,
      ease: 'power2',
      opacity: 1
    }, 'second')

    tl.fromTo(this.$text, {
      opacity: 0,
      y: -50
    }, {
      duration: 0.5,
      y: 0,
      ease: 'power2',
      opacity: 1
    }, 'second')

    tl.fromTo(this.$cta, {
      opacity: 0,
      y: -50
    }, {
      duration: 0.5,
      ease: 'power2',
      opacity: 1,
      y: 0
    }, 'second+=0.2')

    return tl
  }

  reveal() {
    for (let i = 0; i < this.sectionsDatas.length; i++) {
      const section = this.sectionsDatas[i];

      const tl = gsap.timeline({
        paused: true,
        scrollTrigger: {
          trigger: section.el,
          start: 'top center+=300px'
        }
      })

      tl.fromTo(section.el, {
        opacity: 0
      }, {
        duration: 0.8,
        ease: 'power2',
        opacity: 1
      })

      if (section.hasContent) {
        tl.add(this.revealContent(section.el.querySelector('.c-content')), '-=0.5')
      }

      switch (section.type) {
        case 'b-pictos':
          tl.fromTo(section.el.querySelectorAll('.b-pictos__item'), {
            opacity: 0,
            y: -50
          }, {
            duration: 0.8,
            ease: 'power2',
            opacity: 1,
            y: 0,
            stagger: {
              from: 'start',
              amount: 0.5
            }
          }, '-=0.25')
          break;

        case 'b-mozaic':
          tl.fromTo(section.el.querySelectorAll('.card-w'), {
            opacity: 0,
            y: -50
          }, {
            duration: 0.8,
            ease: 'power2',
            opacity: 1,
            y: 0,
            stagger: {
              from: 'start',
              amount: 0.9
            }
          }, '-=0.25')
          break;

        default: break;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/Section.js